.introSection {
  background-image: url(~/src/images/home-intro-image.png?as=webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100vw;
  height: 83vh;
  display: flex;
  align-items: center;
  color: var(--secondary-color);
}

.nameAndBioContainer {
  margin-left: 0;
  padding-left: 1.4rem;
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.63);
}

.nameAndBioContainer h1 {
  padding: 0;
}

.nameAndBioContainer div {
  font-family: "Nunito Variable", sans-serif;
}

.bio {
  margin-top: 7px;
  font-size: var(--large-text);
}

/* Tablet */
@media (min-width: 768px) {
  .nameAndBioContainer {
    padding-left: 3.5rem;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .nameAndBioContainer {
    margin-left: initial;
    padding-left: 4rem;
    width: initial;
    height: initial;
    display: block;
    background-color: initial;
  }
  .introSection {
    background-size: contain;
    background-position: right center;
    height: 100vh;
  }
  .bio {
    margin-top: initial;
    font-size: initial;
  }
}
